import pageStyles from "../VirtualAuditPage.module.scss";
import styles from "./BoilerplateSection.module.scss";

const ABOUT_TEXT =
    `Audette's proprietary, AI-enabled energy modeling platform analyzes buildings for retrofits and capital projects` +
    ` that are financially justified within the context of the asset's underwriting and investment strategy. Rather` +
    ` than provide a purely engineering-focused assessment, the analysis extends beyond technical energy performance` +
    ` and incorporates a financial, regulatory, and ownership-structure lens in order to identify economically` +
    ` accretive pathways to reduce operating costs, avoid fines and earn ancillary revenue.`;

const METHODOLOGY_TEXT =
    `This analysis was conducted using Audette's physics-based energy modeling platform, which generates a` +
    ` building-specific energy model from documentation provided by the client. The process follows an` +
    ` equipment-first approach: known building characteristics (construction vintage, gross floor area, mechanical` +
    ` systems, and envelope data) are ingested from client-supplied records including property condition assessment` +
    ` and utility data. Where inputs are unavailable, engineering design rules infer likely system configurations` +
    ` for a building of that type, age, and climate zone. The assembled model is then evaluated through neural` +
    ` networks trained on over one million EnergyPlus simulations, producing end-use load profiles equivalent to` +
    ` those from a purpose-built energy model. Where utility data is provided, the model is calibrated against` +
    ` actual consumption records, adjusting envelope and load assumptions to align with measured performance.\n\n` +
    `Measure analysis and project sequencing are performed interactively: each candidate energy conservation` +
    ` measure is evaluated in sequence, with the energy impacts of prior measures carried forward. This accounts` +
    ` for thermodynamic interactions between measures — for example, envelope improvements reducing downstream` +
    ` heating and cooling loads. Equipment replacement timing is governed by ASHRAE standard service life estimates` +
    ` applied to known installation dates, constraining recommendations to realistic capital planning horizons.`;

const DISCLAIMER_TEXT =
    `The actual energy, carbon, and cost savings realized by implementing carbon reduction measures depend upon a` +
    ` wide variety of factors beyond the control of Audette. These factors include, but are not limited to,` +
    ` climate conditions, operating procedures, building occupancy and scheduling. Accordingly, Audette does not` +
    ` expressly or implicitly warrant or represent that Audette's energy and implementation cost estimates of` +
    ` building or equipment operation will be the actual energy consumption and cost.\n\n` +
    `Furthermore, Audette does not expressly or implicitly warrant or represent that the cost estimates included` +
    ` in this report will be the actual cost of implementing the recommended carbon reduction measures. Project` +
    ` cost estimates can vary depending on factors including, but are not limited to, fluctuations in material and` +
    ` labor costs, changes in project scope or specifications, market conditions at time of procurement,` +
    ` site-specific conditions discovered during implementation, contractor availability and pricing.\n\n` +
    `Our intent, given the time and budget parameters of this analysis, is to provide enough information at a` +
    ` level of accuracy that will allow the owner to make informed decisions about carbon reduction measures. For` +
    ` capital projects, we do recommend obtaining detailed engineering designs and contractor quotes before making` +
    ` financial commitments.`;

function BoilerplateSection() {
    return (
        <div>
            <h2 className={pageStyles.sectionTitle}>About Audette</h2>
            <p className={styles.bodyText}>{ABOUT_TEXT}</p>

            <h3 className={styles.subheading}>Methodology</h3>
            {METHODOLOGY_TEXT.split("\n\n").map((para) => (
                <p key={`methodology-${para.substring(0, 20).replace(/\s+/g, "-")}`} className={styles.paragraph}>
                    {para}
                </p>
            ))}

            <h3 className={styles.subheadingSpaced}>Cost &amp; Savings Disclaimer</h3>
            {DISCLAIMER_TEXT.split("\n\n").map((para) => (
                <p
                    key={`disclaimer-${para.substring(0, 20).replace(/\s+/g, "-")}`}
                    className={styles.disclaimerParagraph}
                >
                    {para}
                </p>
            ))}
        </div>
    );
}

export default BoilerplateSection;
